import React,{useLayoutEffect,useRef,useState} from 'react';
import {createPortal} from 'react-dom';
import {Pencil,Trash2} from 'lucide-react';
import './EventActionMenu.css';

export default function EventActionMenu({x,y,recurring,readOnly,message,onAction,onClose}) {
  const menu=useRef(null),[position,setPosition]=useState({left:0,top:0});
  useLayoutEffect(()=>{
    const node=menu.current,previous=document.activeElement;
    const bounds=node.getBoundingClientRect();
    setPosition({left:Math.max(8,Math.min(x??window.innerWidth/2,window.innerWidth-bounds.width-8)),top:Math.max(8,Math.min(y??window.innerHeight/2,window.innerHeight-bounds.height-8))});
    (node.querySelector('button')||node).focus();
    return()=>{if(previous?.isConnected)previous.focus();};
  },[x,y]);
  const actions=recurring?[['edit-instance','Edit This Instance'],['edit-future','Edit This and All Future'],['delete-instance','Delete This Instance'],['delete-future','Delete This and All Future']]:[['edit','Edit'],['delete','Delete']];
  return createPortal(<div className="event-action-menu-layer" onPointerDown={event=>{if(event.target===event.currentTarget)onClose();}} onContextMenu={event=>{event.preventDefault();if(event.target===event.currentTarget)onClose();}}>
    <div ref={menu} style={position} className="event-action-menu" role="menu" aria-label="Event actions" tabIndex={-1} onKeyDown={event=>{
      if(event.key==='Escape'||event.key==='Tab'){event.preventDefault();onClose();return;}
      if(!['ArrowDown','ArrowUp','Home','End'].includes(event.key))return;
      event.preventDefault();const buttons=[...menu.current.querySelectorAll('button:not(:disabled)')];
      const index=buttons.indexOf(document.activeElement),next=event.key==='Home'?0:event.key==='End'?buttons.length-1:(index+(event.key==='ArrowDown'?1:-1)+buttons.length)%buttons.length;
      buttons[next]?.focus();
    }}>
      {readOnly?<p role="status">{message}</p>:actions.map(([id,label])=>{const deleting=id.startsWith('delete'),Icon=deleting?Trash2:Pencil;return <button type="button" role="menuitem" className={deleting?'is-destructive':''} key={id} onClick={()=>onAction(id)}><Icon size={15}/>{label}</button>;})}
    </div>
  </div>,document.body);
}
